// import RulePack from './RulePack';

export default {
  priority: 1,
  path: "packet",
  permissions: ["RequestsMenu/RequestPattern/PatternDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./RulePack")
  ),
  name: "جدول مالیات و بیمه",
  icon: "content-paste",
  drawer: true,
};
